import axiosInstance from "@/lib/axiosInstance";
import { useQuery } from "@tanstack/react-query";

export interface FileTagOption {
  id: string | number;
  name: string;
  metadata?: unknown;
}

interface FileTagDropdownResponse {
  success: boolean;
  data: FileTagOption[];
  pagination: {
    limit: number;
    nextCursor: string | null;
    hasMore: boolean;
  };
}

export const FileTagQueryKeys = {
  dropdown: "fileTagDropdown",
} as const;

export const getFileTagOptions = async (search?: string): Promise<FileTagOption[]> => {
  const params = new URLSearchParams();
  params.set("type", "FileTag");
  params.append("field", "name");
  params.append("field", "id");
  if (search?.trim()) params.set("search", search.trim());
  const { data } = await axiosInstance.get<FileTagDropdownResponse>(
    `/dropdown?${params.toString()}`,
  );
  return data.data ?? [];
};

export const useFileTagDropdown = (search: string) =>
  useQuery({
    queryKey: [FileTagQueryKeys.dropdown, search],
    queryFn: () => getFileTagOptions(search),
    enabled: search.length > 0,
  });
